<template>
  <div class="chat-emotion" @click.stop :class="{ show: value }">
    <picker
      :i18n="i18n"
      @select="emoji => $emit('select', emoji)"
      :showSearch="false"
      :showPreview="false"
      :showSkinTones="true"
      :defaultSkin="1"
      color="#1988ef"
    />
  </div>
</template>

<script>
import { Picker } from "emoji-mart-vue";
export default {
  name: "chat-emotion",
  data() {
    return {
      i18n: {
        search: "搜索",
        notfound: "没有找到对应的表情",
        categories: {
          search: "搜索结果",
          recent: "最近常用",
          people: "笑脸和人",
          nature: "动物与自然",
          foods: "食物和饮料",
          activity: "活动",
          places: "旅行",
          objects: "物件",
          symbols: "符号",
          flags: "旗帜",
          custom: "自定义"
        }
      }
    };
  },
  components: {
    Picker
  },
  props: {
    value: Boolean
  },
  methods: {
    close() {
      this.$emit("input", false);
    }
  }
};
</script>

<style scoped lang="less">
.chat-emotion {
  @height: 200px;
  height: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  background-color: #fff;
  z-index: -1;
  transition-duration: 0.3s;
  display: flex;
  flex-direction: column;
  user-select: none;
  opacity: 0;
  border-top: 1px solid var(--border-color);
  visibility: hidden;

  /deep/ .emoji-mart {
    width: 100% !important;
    border-radius: 0;
    height: 0;
    border: none;

    .emoji-mart-bar {
      .emoji-mart-anchors {
        justify-content: flex-start;
        .emoji-mart-anchor {
          flex-basis: 50px;
          flex-grow: inherit;
          padding: 7px 4px;
        }
      }
    }
  }

  .type-list {
    height: 30px;
    padding: 0 15px;
  }

  .emoji-list {
    border-top: 1px solid var(--border-color);
    flex: 1;
    padding: 15px;
  }

  &.show {
    @height: 200px;
    height: @height;
    opacity: 1;
    z-index: 99;
    top: @height * -1 - 1;
    visibility: visible;

    /deep/ .emoji-mart {
      height: @height;
    }
  }
}
</style>
